module.exports = __webpack_public_path__ + "img/esp_con.3526325f.png";